/**
 * リクエスト
 */
export class WlMasterDataRequest {
	public companyProductCode: string = null; // 保険商品コード
}